<template>
  <div class="container_welcome" :style="{ backgroundImage: getBackground() }">
    <div class="welcome_cover_white">
      <b-container fluid class="container_welcome_data">
        <b-row style="height:549px;">
          <b-col cols="12" class="mt-3 text-right"><button @click="enterRegisterModal=!enterRegisterModal" class="welcome_login_button" :style="{color:getCssColor('primary_bt')}">Entrar ou Cadastrar</button></b-col>
          <!-- logo -->
          <b-col cols="12" style="height:200px;text-align:center;">
            <b-row style="height:100%">
                <b-col class="align-self-center"><img v-if="logo" :src="logo" alt="logo" class="welcome_logo"/></b-col>
            </b-row>
          </b-col>
          <!-- title and blocks -->
          <b-col style="height:260px;" cols="12" class="align-self-end">
            <b-row style="height:260px;" class="align-items-end">
              <b-col class="block_title" cols="12" style="height:calc(100% - 132px);" :style="{color:getCssColor('primary_bt')}">
                <b-row style="height:100%;">
                  <b-col class="align-self-end" style="text-align:center;">{{$store.state.company.blocks.title}}</b-col>
                </b-row>
              </b-col>
              <b-col class="block_subtitle" cols="12" style="height:60px;"  :style="{color:getCssColor('secondary_bt')}">
                <b-row style="height:100%;">
                  <b-col class="align-self-center" style="text-align:center;">{{$store.state.company.blocks.subtitle}}</b-col>
                </b-row>
              </b-col>
              <b-col cols="12" style="height:72px;text-align:center;">
                <button class="where_are_you_button" @click="whereAreYouModal=true; onCloseAddressContinueRegister=false" :style="{ backgroundColor:getCssColor('primary_bt') }">Clique aqui!</button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container fluid class="container_welcome_data">
      <b-row >
        <b-col cols="12">
          <!-- banner welcome -->
          <b-row>
            <b-col class="mb-3 text-center">
              <img v-if="getBannerWelcome()" :src="getBannerWelcome()" class="welcome_banner" style="width:100%;"/>
            </b-col>
          </b-row>
          <b-row align-h="center" class="mb-3" v-if="native === false && ( $store.state.company.android_app_id || $store.state.company.ios_app_id)">
          <!-- gett apps -->
            <b-col cols="12" style="text-align:center;font-size:34px;font-weight:500;" :style="{color:getCssColor('primary_bt')}">
              Baixe o <span style="font-weight:bold;">App!</span>
            </b-col>
            <b-col cols="6" md="3" class="mt-3 mb-4 text-right">
              <a :href="'https://play.google.com/store/apps/details?id=' + $store.state.company.android_app_id" rel="noreferrer" target="_blank">
                <img src="https://cdnimages.opa4.store/img/fixedimg/get_google_play.png">
              </a>
            </b-col>
            <b-col cols="6" md="3" class="mt-3 mb-4 text-left">
              <a :href="'https://itunes.apple.com/us/app/' + $store.state.company.ios_app_id" rel="noreferrer" target="_blank">
                <img src="https://cdnimages.opa4.store/img/fixedimg/get_apple_store.png">
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <Footer />

    <!-- enter or register -->
    <EnterOrRegister 
      v-model="enterRegisterModal" 
      :addressRequiredForRegister="true" 
      @loginRegisterLogged="() => { loggedIn() }" 
      @slideModalChange="(val) => { enterRegisterModal = val }"
      @requestAddressToRegister="(val) => { whereAreYouModal = true; onCloseAddressContinueRegister = true }"
      />

    <!-- component of consumer location -->
    <WhereAreYou v-model="whereAreYouModal" @slideModalChange="(val) => whereAreYouModal = val" @continueWithAddress="(latLong) => continueWithAddress(latLong)" />

  </div>
</template>

<script>
/* global NATIVE */
import colors from '@/mixins/colors'
import Footer from '@/components/Footer'
import { EventBus } from '@/behaviours/event-bus'
import WhereAreYou from  '@/components/WhereAreYou'
import EnterOrRegister from '@/components/EnterOrRegister'
import LocationConn from '@/connection/location'

export default {

  data () {
    return {
      native: NATIVE,
      enterRegisterModal: false,
      whereAreYouModal: false,
      onCloseAddressContinueRegister: false
    }
  },

  mixins: [colors],

  components: {Footer, WhereAreYou, EnterOrRegister},

  computed: {
    logo () {
      if (!this.$store.getters.getLogo) {
        return null
      } else if (!this.$store.state.company.logo_welcome) {
        return this.$store.getters.getLogo
      } else {
        return this.$store.state.company.logo_welcome
      }
    }
  },

  created () {
    this.$store.state.choicedCompanyId = null
    this.$store.state.choicedCompany = null
    this.$store.state.selectedAddressShort = null
    // TODO fix it to navigation
    this.$store.state.registerLoginOrigin = 'stay'
    if (this.$route.query.login) {
      this.loginModal = true
    }
  },

  methods: {
    getBackground () {
      if (this.$mq === 'mobile' || this.$mq === 'tablet') {
        if (this.$store.state.company.blocks.bg_small) {
          return 'url(https://cdnimages.opa4.store/img/' + this.$store.state.company.companyId + '/block/' + this.$store.state.company.blocks.bg_small + ')'
        } else {
          return null
        }
      } else {
        if (this.$store.state.company.blocks.bg_large) {
          return 'url(https://cdnimages.opa4.store/img/' + this.$store.state.company.companyId + '/block/' + this.$store.state.company.blocks.bg_large + ')'
        } else {
          return null
        }
      }
    },

    getBannerWelcome () {
      if (this.$mq === 'mobile' || this.$mq === 'tablet') {
        if (this.$store.state.company.blocks.banner_small) {
          return 'https://cdnimages.opa4.store/img/' + this.$store.state.company.companyId + '/block/' + this.$store.state.company.blocks.banner_small
        } else {
          return null
        }
      } else {
        if (this.$store.state.company.blocks.banner_large) {
          return 'https://cdnimages.opa4.store/img/' + this.$store.state.company.companyId + '/block/' + this.$store.state.company.blocks.banner_large
        } else {
          return null
        }
      }
    },

    async loggedIn () {

      console.log('EVENT loggedIn')
      this.$store.state.showLoading = true

      // user loged in with address
      if (this.$store.state.user && this.$store.state.user.adresses.length) {
        let addr = this.$store.state.user.adresses[this.$store.state.user.adresses.length -1]
        // add the selected ID to session for use in checkout
        this.$store.state.selectedAddressId = addr.id
        // addr short name to selects
        this.$store.state.selectedAddressShort = addr.shortName
        if (this.$store.state.company.block_address_navigation === "YES_LIST") {
          this.$store.state.lastLatLongUri = addr.latLong.lat + '/' + addr.latLong.lng
          this.$router.push({path: '/company_list/' + addr.latLong.lat + '/' + addr.latLong.lng})
          this.$store.commit('setLoadingView',false)
        } else {
          //Auto choice and go to home
          // flag the need of address alertModal
          this.$store.state.addressAlertModal = true
          this.$store.state.lastLatLongUri = addr.latLong.lat + '/' + addr.latLong.lng
          console.log('WAIT GET SUBCOMPANY')
          let result = await LocationConn.getCompaniesByLocation(addr.latLong.lat, addr.latLong.lng)
          console.log(result)
          if (!result.error && result.length){
            let companyResult = result[0]
            this.$store.commit('setProducts', [])
            this.$store.commit('setProductList', [])
            this.$store.commit('setCategories', [])
            this.$store.state.fetchingAllProducuts = false
            this.$store.commit('setChoicedCompanyId', companyResult.companyId)
            this.$store.commit('setChoicedCompany', companyResult)
            console.log('GO TO PATH')
            this.$router.push({path:'/home'})
            this.$store.commit('setLoadingView',false)
          } else {
            console.log('NOT ATTEND')
            // TODO full page not attend fall back not region to be
            this.$router.push({path: '/company_list/' + addr.latLong.lat + '/' + addr.latLong.lng})
            this.$store.commit('setLoadingView',false)
          }
        }
        this.$store.state.showLoading = false
      // user logged in without address
      } else if (this.$store.state.user) {
        this.$store.state.showLoading = false
        this.whereAreYouModal = true
      }

    },

    async continueWithAddress (latLong) {
      // if user is not registering now
      if (!this.onCloseAddressContinueRegister) {
        if (this.$store.state.company.block_address_navigation === "YES_LIST") {
          this.$router.push({path: '/company_list/' + this.$store.state.lastLatLongUri})
        } else {
          let result = await LocationConn.getCompaniesByLocation(latLong.lat, latLong.lng)
          console.log(result)
          if (!result.error){
            let companies = result
            if (companies.length) {
              let company = companies[companies.length-1]
              this.$store.commit('setChoicedCompanyId', company.companyId)
              this.$store.commit('setChoicedCompany', company)
              this.$router.push({path:'/home'})
            } else {
              // no companies
              this.$router.push({path: '/company_list/' + this.$store.state.lastLatLongUri})
            }
          } else {
            EventBus.$emit('showAlert', 'error', result.msg)
          }
        }
      } else {
        // if user is registering without tem address
        this.$store.state.showLoading = false
        EventBus.$emit('continueWithRegistration')
      }
    },
  }

}
</script>

<style lang="scss">

@import "@/css/_variables.scss";

.container_welcome {
  margin:0px auto;
  background-color:#F9FAFB;
  background-position: top center;
  background-repeat: no-repeat;
  position:relative;
  width:100vw;
  background-size: 100% 549px;
  @media screen and (max-width: $tablet_max) {
    //background-size:cover;
  }

}

.container_welcome_data {
  max-width:1336px;
}

.welcome_login_button {
  height: 34px;
  width: 152px;
  background-color: #ffffff;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  border-radius: 6px;
  border: 0px;
}
.where_are_you_button {
  width:100%;
  height: 44px;
  max-width:322px;
  color:#ffffff;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  border:0px;
  border-radius: 5px;
}

.welcome_cover_white{
  background-repeat: no-repeat;
  background-position: bottom center;
  background: linear-gradient(0deg, #F9FAFB 32%, rgba(255, 255, 255, 0) 57%);
  height:549px;
}

.block_title {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
}

.block_subtitle {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
}

.welcome_logo {
  max-width: 328px;
  @media screen and (max-width: $tablet_max) {
    max-width: 204px;
  }
}

.welcome_banner {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius:8px;
  max-width:1318px;
  @media screen and (max-width: $tablet_max) {
    //background-size:cover;
    max-width:322px;
  }
}




</style>
